import TooltipButton from "./styled-components/TooltipButton";

// common imports
import TooltipIcon from "common/svg/TooltipIcon";
import { MouseEventHandler } from "react";

interface TooltipProps {
  size?: number;
  color?: string;
  onClick: MouseEventHandler;
}

function Tooltip({ color, size = 20, onClick }: TooltipProps) {
  return (
    <TooltipButton color={color} onClick={onClick}>
      <TooltipIcon size={size} />
    </TooltipButton>
  );
}

export default Tooltip;
